import { ApolloLink } from '@apollo/client';

/** Configure app name here */
const appName = 'provider-dashboard';

/**
 * Sets standard headers for all Mantra requests including app version, build, platform.
 */
export const mantraAppInfoLink: ApolloLink = new ApolloLink((operation, forward) => {
  const appInfoHeaders = {
    'X-Mantra-App-Name': appName,
    'X-Mantra-App-Platform': 'web',
    // TODO
    // 'X-Mantra-App-Version': version,
    // 'X-Mantra-App-Build': build,
  } as const;

  const { headers: existingHeaders } = operation.getContext();

  operation.setContext({ headers: { ...existingHeaders, ...appInfoHeaders } });

  return forward(operation);
});
